module.exports = __webpack_public_path__ + "static/media/24UHCHR23.84d9afd4.jpg";